(function () {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * @ngdoc directive
     * @name ihh-common-web.ihh-form-controls
     * @restrict AE
     * @scope
     *
     * @param {object} ihhForm form which relates to the directive
     * @param {object} prescriptionForm optional prescription form object
     * @param {function} saveFunction function to execute on save
     * @param {function} cancelFunction function to execute on cancel
     * @param {boolean} innerNav variable to determine if buttons are within innerNav
     *
     * @description
     *  This directive is used to create the save/cancel controls on forms.
     *  These buttons will check for validity prior to executing their
     *  respective actions and update the alert banner accordingly
     *
     * @example
     * <ihh-form-controls
     *  ihh-form="protocolForm"
     *  save-function="save"
     *  cancel-function="cancel">
     * </ihh-form-controls>
     */
    angular
        .module('ihh-common-web')
        .directive('ihhFormControls', ihhFormControls);

    function ihhFormControls() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                ihhForm: '=',
                ihhFormIgnores: '=',
                prescriptionForm: '=',
                saveFn: '=',
                cancelFn: '=',
                saveAndNewFn: '=',
                innerNav: '=',
                isExpanded: '=',
                saveFnLabel: '@',
                cancelFnLabel: '@',
                saveGlyphiconClass: '@'
            },
            templateUrl: 'form/form-update-controls.tpl.html',
            controller: 'formUpdateCtrl'
        };
    }
})();
